<template>
  <ts-loading-banner :loading="loading">
    <div class="ts-space-y-3">
      <div>
        <label class="required">{{ $t('wholesale.employee') }}</label>
        <!-- <a-select
					v-model="model.seller_id"
					:options="employeeList"
					:filterOption="
						(input, option) =>
							option.componentOptions.children[0].text
								.toLowerCase()
								.indexOf(input.toLowerCase()) >= 0
					"
					showSearch
					class="ts-w-full"
				></a-select> -->
        <a-select
          v-model="model.seller_id"
          show-search
          style="width: 100%"
          :default-active-first-option="false"
          :show-arrow="false"
          :filter-option="false"
          :not-found-content="null"
          :placeholder="$t('wholesale.customer')"
          @search="handleSaleSearch"
        >
          <a-select-option v-for="emp in employeeList" :key="emp.employee_id">
            {{ emp.employee_name_en }}
          </a-select-option>
        </a-select>
        <div class="validate" v-if="errors.has('seller_id')">
          {{ errors.first('seller_id') }}
        </div>
      </div>
      <div class="ts-space-y-3">
        <div>
          <label class="required">{{ $t('wholesale.customer') }}</label>
          <div class="ts-flex ts-items-center">
            <!-- <a-select
							v-model="model.customer_id"
							:filterOption="
								(input, option) =>
									option.componentOptions.children[0].text
										.toLowerCase()
										.indexOf(input.toLowerCase()) >= 0
							"
							showSearch
							:options="customerList"
							class="ts-w-full"
						></a-select> -->

            <a-select
              v-model="model.customer_id"
              show-search
              style="width: 100%"
              :default-active-first-option="false"
              :show-arrow="false"
              :filter-option="false"
              :not-found-content="null"
              :placeholder="$t('wholesale.customer')"
              @search="handleCustomerSearch"
            >
              <a-select-option v-for="c in customerList" :key="c.customer_id">
                {{ c.customer_name }}
              </a-select-option>
            </a-select>
          </div>
          <div class="validate" v-if="errors.has('customer_id')">
            {{ errors.first('customer_id') }}
          </div>
        </div>
      </div>

      <div class="ts-space-y-3">
        <div>
          <label>{{ $t('wholesale.owner') }}</label>
          <div class="ts-flex ts-items-center">
            <!-- <a-select
							v-model="model.customer_id"
							:filterOption="
								(input, option) =>
									option.componentOptions.children[0].text
										.toLowerCase()
										.indexOf(input.toLowerCase()) >= 0
							"
							showSearch
							:options="customerList"
							class="ts-w-full"
						></a-select> -->

            <a-select
              v-model="model.customer_id_ref"
              show-search
              allow-clear
              style="width: 100%"
              :default-active-first-option="false"
              :show-arrow="false"
              :filter-option="false"
              :not-found-content="null"
              :placeholder="$t('wholesale.ownerList')"
              @search="handleOwnerSearch"
              @change="handleOwnerClear"
            >
              <a-select-option v-for="o in ownerList" :key="o.customer_id">
                {{ o.customer_name }}
              </a-select-option>
            </a-select>
          </div>
          <div class="validate" v-if="errors.has('customer_id_ref')">
            {{ errors.first('customer_id_ref') }}
          </div>
        </div>
      </div>

      <div class="ts-space-y-3">
        <div>
          <label>{{ $t('wholesale.refInvoiceNumber') }}</label>
          <a-input
            v-model="model.ref_invoice_number"
            :placeholder="$t('wholesale.referenceNo')"
            style="width: 100%"
          />
          <div class="validate" v-if="errors.has('ref_invoice_number')">
            {{ errors.first('ref_invoice_number') }}
          </div>
        </div>
      </div>

      <div class="ts-space-y-3">
        <div class="ts-flex ts-justify-end ts-items-end ts-space-x-3">
          <ts-button @click.prevent="$emit('cancel')">{{
            $t('cancel')
          }}</ts-button>
          <ts-button @click.prevent="onCheckAndUpdate" color="primary">{{
            $t('update')
          }}</ts-button>
        </div>
      </div>
    </div>
  </ts-loading-banner>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapActions } from 'vuex'
import { debounce } from 'lodash'

export default {
  name: 'editMainInvoice',
  props: ['editData'],
  data() {
    return {
      errors: new Errors(),
      loading: false,
      model: {
        seller_id: null,
        customer_id: null,
        customer_id_ref: null,
        ref_invoice_number: null,
      },
      employeeList: [],
      customerList: [],
      ownerList: [],
    }
  },
  created() {
    this.setData()
  },
  methods: {
    ...mapActions('wholesale/operation', ['getFormViewData', 'updateMain', 'checkRefInvoiceNumber']),
      handleOwnerClear(value) {
      if (value === undefined) {
        this.model.customer_id_ref = null
      }
    },
    handleCustomerSearch: debounce(function (value) {
      this.loading = true
      this.getFormViewData({
        params: {
          fnName: 'customer',
          search_customer: value,
          vatin: this.editData.customer ? this.editData.customer.vatin : null,
        },
      })
        .then((response) => {
          this.customerList = response.data.customer
        })
        .finally(() => (this.loading = false))
    }, 1000),
    handleOwnerSearch: debounce(function (value) {
      this.loading = true
      this.getFormViewData({
        params: {
          fnName: 'customer',
          search_customer: value,
        },
      })
        .then((response) => {
          this.ownerList = response.data.customer
        })
        .finally(() => (this.loading = false))
    }, 1000),
    handleSaleSearch: debounce(function (value) {
      this.loading = true
      this.getFormViewData({
        params: {
          fnName: 'sale',
          search_sale: value,
        },
      })
        .then((response) => {
          this.employeeList = response.data.sale
        })
        .finally(() => (this.loading = false))
    }, 1000),
    onCheckAndUpdate() {
      if (!this.model.ref_invoice_number) {
        this.onUpdate()
        return
      }

      this.loading = true
      this.checkRefInvoiceNumber({
        ref_invoice_number: this.model.ref_invoice_number,
        exclude_id: this.editData.stock_out_id  // exclude current record
      })
        .then((response) => {
          if (response.exists) {
            this.$confirm({
              title: this.$t('are_you_sure'),
              content: this.$t('wholesale.refInvoiceNumberAlreadyExists'),
              okText: this.$t('yes'),
              cancelText: this.$t('no'),
              onOk: () => {
                this.onUpdate()
              }
            })
          } else {
            this.onUpdate()
          }
        })
        .catch((error) => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    onUpdate() {
      this.loading = true
      this.errors = new Errors()
      this.updateMain({
        id: this.editData.stock_out_id,
        data: this.model,
      })
        .then((response) => {
          this.$toasted.success(response.message)
          this.$emit('cancel')
        })
        .catch((error) => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.loading = false
        })
    },
    setData() {
      this.employeeList = []
      this.customerList = []
      this.ownerList = []

      if (this.editData.customer) {
        this.customerList.push(this.editData.customer)
      }

      if (this.editData.sale) {
        this.employeeList.push(this.editData.sale)
      }

      if (this.editData.owner) {
        this.ownerList.push(this.editData.owner)
      }

      this.model.seller_id = this.editData.seller_id
      this.model.customer_id = this.editData.customer_id
      this.model.customer_id_ref = this.editData.customer_id_ref
      this.model.ref_invoice_number = this.editData.ref_invoice_number
    },
  },
}
</script>
